enum CustomerPhoneType {
  PHONE = 'PHONE',
  MOBILE = 'MOBILE',
}

export default CustomerPhoneType;
